import { render } from "./FAQ.vue?vue&type=template&id=a8f82672&scoped=true"
import script from "./FAQ.vue?vue&type=script&lang=js"
export * from "./FAQ.vue?vue&type=script&lang=js"

import "./FAQ.vue?vue&type=style&index=0&id=a8f82672&lang=scss&scoped=true"

import exportComponent from "/Users/andreigeana/Documents/Projects/KidsStuff/babies/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8f82672"]])

export default __exports__